import type { PatternKey } from '@/components/pattern/pattern';

export interface GameTheme {
    name: string;
    label: string;
    pattern: PatternKey;
}

export const Themes: GameTheme[] = [
    {
        name: 'light',
        label: 'Light (Default)',
        pattern: 'i-like-food',
    },
    {
        name: 'dark',
        label: 'Dark Theme',
        pattern: 'piano-man',
    },
    {
        name: 'forest',
        label: 'Forest Green',
        pattern: 'hexagons',
    },
    {
        name: 'midnight',
        label: 'Midnight',
        pattern: 'zig-zag-2',
    },
    {
        name: 'sunset',
        label: 'Sunset Orange',
        pattern: 'signal',
    }
];
